// src/components/strumenti/CalcoloIVA.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function CalcoloIVA() {
  const [modo, setModo] = useState("aggiungi"); // aggiungi = da netto a lordo, scorpora = da lordo a netto
  const [valore, setValore] = useState("");
  const [aliquota, setAliquota] = useState("22");

  const v = leggiNumero(valore)||0;
  const al = leggiNumero(aliquota)||0;

  const imponibile = modo==="aggiungi" ? v : v/(1+al/100);
  const importoIva = modo==="aggiungi" ? v*(al/100) : v - (v/(1+al/100));
  const totale = modo==="aggiungi" ? v + importoIva : v;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("aggiungi");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="aggiungi"?"#059669":"#e5e7eb"}`, background: modo==="aggiungi"?"#ecfdf5":"#fff", color: modo==="aggiungi"?"#059669":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Da netto → aggiungi IVA</button>
        <button onClick={()=>{setModo("scorpora");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="scorpora"?"#059669":"#e5e7eb"}`, background: modo==="scorpora"?"#ecfdf5":"#fff", color: modo==="scorpora"?"#059669":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Da lordo → scorpora IVA</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>{modo==="aggiungi" ? "Importo netto (€)" : "Importo lordo/totale (€)"}</label>
          <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder="Es. 1000"/>
        </div>
        <div>
          <label style={lbl}>Aliquota IVA</label>
          <select value={aliquota} onChange={e=>setAliquota(e.target.value)} style={inp}>
            <option value="4">4%</option>
            <option value="5">5%</option>
            <option value="10">10%</option>
            <option value="22">22%</option>
          </select>
        </div>
      </div>

      <div style={{ background:"#ecfdf5", border:"1px solid #a7f3d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", fontSize:11, color:"#6b7280" }}>
          <div style={{textAlign:"center"}}>
            <div>Imponibile</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:15}}>{v>0 ? imponibile.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div>IVA ({aliquota}%)</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:15}}>{v>0 ? importoIva.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div>Totale</div>
            <div style={{fontWeight:800, color:"#059669", fontSize:15}}>{v>0 ? totale.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2}) : "—"} €</div>
          </div>
        </div>
      </div>

      <button onClick={()=>{setValore("");setAliquota("22");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
